import { render, staticRenderFns } from "./animal_variety.vue?vue&type=template&id=3f3bb0d8"
import script from "./animal_variety.vue?vue&type=script&lang=js"
export * from "./animal_variety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports